import numeral from 'numeral';

export default (value: number | string, showDecimals: boolean = true) => {
    if (value == null) {
        return null;
    }

    const parsedValue = parseFloat(value);

    if (!showDecimals) {
        return numeral(parsedValue).format('0,0');
    }

    return Math.abs(parsedValue) < 1
        ? parsedValue.toPrecision(2)
        : numeral(parsedValue).format('0,0.0');
};
